<template>
  <div class="follow-up-business">
    <el-row :gutter="40" type="flex" class="flex-wrap">
      <el-col :span="12" v-for="item in businessList" :key="item.code">
        <div class="business-card">
          <!-- 圆形图标 -->
          <div class="card-icon">
            <span class="icon-text">{{ item.code }}</span>
          </div>
          <!-- 标题 -->
          <h3 class="card-title">{{ item.title }}</h3>
          <!-- 描述 -->
          <p class="card-desc">{{ item.description }}</p>
          <!-- 申请按钮 -->
          <el-button class="apply-btn" @click="handleApply(item)">
            立即申请
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getDicts } from '@/api/user.js'
export default {
  name: 'FollowUpBusiness',
  data() {
    return {
      // 业务列表 - 假数据，后续可从接口获取
      businessList: [
        {
          code: 'SZ62',
          title: '撤销数字版权登记申请',
          description: '主动撤销，或根据最终司法判决和著作权行政处罚决定撤销数字版权登记',
          customerServiceUrl: ''
        },
        {
          code: 'D62',
          title: '撤销DCI登记申请',
          description: '主动撤销DCI登记作品',
          customerServiceUrl: ''
        },
        {
          code: 'SZ63',
          title: '撤回数字版权登记申请',
          description: '在登记申请批准之前，请求撤回申请',
          customerServiceUrl: ''
        },
        // {
        //   code: 'SZ81',
        //   title: '数字版权登记退费申请',
        //   description: '无法补正申请退回数登申请费用',
        //   customerServiceUrl: ''
        // },
      ],
      customerServiceUrl: '',
    }
  },
  methods: {
    // 点击立即申请 - 跳转企业微信客服
    handleApply(item) {
      const url = item?.customerServiceUrl || this.customerServiceUrl || ''
      if (url) {
        window.open(url)
        return
      }
      this.$message.info('客服链接未配置')
    }
  },
  async mounted(){
    const { data } = await getDicts('sd_houxu')
    const { dictValue } = data?.[0] || {}
    this.customerServiceUrl = dictValue || ''
  },
}
</script>

<style lang="scss" scoped>
.follow-up-business {
  padding: 40px 60px;
}

.flex-wrap {
  flex-wrap: wrap;
}

.business-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 40px;
  margin-bottom: 40px;
  text-align: center;
  height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

// 圆形图标
.card-icon {
  width: 120px;
  height: 120px;
  border: 3px solid #409EFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  .icon-text {
    font-size: 32px;
    font-weight: bold;
    color: #409EFF;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
  }
}

// 标题
.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 15px 0;
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
}

// 描述
.card-desc {
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  line-height: 1.6;
  max-width: 300px;
}

// 申请按钮
.apply-btn {
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 20px;
  padding: 10px 30px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    border-color: #409EFF;
    color: #409EFF;
  }

  .btn-icon {
    width: 20px;
    height: 20px;
  }
}
</style>

